import type React from "react";
import { cn } from "@/utils/shadcn";

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  variant?: "default" | "full-width" | "minimal";
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  action,
  className,
  variant = "default",
  children
}) => {
  if (variant === "full-width") {
    return (
      <header className={cn("border-b border-border bg-card", className)}>
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
              {description && (
                <p className="text-[13.5px] text-muted-foreground mt-1.5">{description}</p>
              )}
            </div>
            {action && <div>{action}</div>}
          </div>
          {children}
        </div>
      </header>
    );
  }

  if (variant === "minimal") {
    return (
      <div className={cn("space-y-1", className)}>
        {description && <p className="text-muted-foreground">{description}</p>}
        {children}
      </div>
    );
  }

  // Default variant
  return (
    <div
      className={cn(
        "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-[22px]",
        className
      )}
    >
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
        {description && <p className="text-[13.5px] text-muted-foreground mt-1.5">{description}</p>}
      </div>
      {action && <div className="mt-4 sm:mt-0">{action}</div>}
      {children}
    </div>
  );
};
